<!-- ═══════════════════════════════════════════════════
     FOOTER COMPONENT  |  selector: app-footer
     ═══════════════════════════════════════════════════ -->
<footer class="relative w-full overflow-hidden bg-white">
 <div class="absolute inset-0 z-0 pointer-events-none" aria-hidden="true">
    <img
      src="/images/Footer-bg.svg"
      alt=""
      class="w-full h-full object-cover object-center"
    />
    <!-- white overlay — adjust opacity to taste -->
  </div>
    <!-- ══ 1. Newsletter Banner ══════════════════════════ -->
    <div class="relative z-10">
        <!-- <div class="w-full pt-10 sm:pt-16 md:pt-20 pb-4">
            <div class="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="bg-[#FEE0E0] rounded-2xl px-5 sm:px-8 md:px-10 py-6 sm:py-7
                  flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-10">

                    <div class="flex-1 min-w-0">
                        <h3 class="text-gray-900 font-semibold text-base sm:text-lg md:text-xl leading-snug">
                            Join our newsletter
                        </h3>
                        <p class="text-gray-500 text-sm mt-1">
                            We'll send you a nice letter once per week. No spam.
                        </p>
                    </div>

                    <div class="flex items-center gap-2 sm:gap-3 w-full sm:w-auto flex-shrink-0">
                        <input type="email" [(ngModel)]="email" placeholder="Enter your email"
                            class="flex-1 sm:w-52 md:w-72 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl border border-gray-200
                            bg-white text-sm text-gray-800 placeholder-gray-400 outline-none
                            focus:border-[#e0144c] focus:ring-2 focus:ring-[#e0144c]/20 transition-all" />
                        <button (click)="onSubscribe()"
                            class="bg-[#e0144c] hover:bg-[#c0103f] active:scale-95 text-white font-semibold
                            text-sm px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl transition-all duration-200 whitespace-nowrap flex-shrink-0">
                            Subscribe
                        </button>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- ══ 2. Main body ═══════════════════════════════════ -->
        <div class="relative w-full overflow-hidden">

            <!-- subtle watermark illustration -->
            <div class="absolute inset-0 pointer-events-none select-none flex items-center justify-center opacity-[0.05]"
                aria-hidden="true">
                <img src="/images/Footer-bg.svg" alt="jhjhjh" class="w-1/2 max-w-lg object-contain" />
            </div>

            <div class="relative z-10 max-w-screen-2xl mx-auto px-8 sm:px-6 lg:px-8
                 pt-8 sm:pt-10 pb-8">

                <!-- grid: logo full-width on mobile/tablet, 5-col on desktop -->
                <div class="grid grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-8 lg:gap-6">

                    <!-- Logo + tagline — full width on mobile/tablet, 1 col on desktop -->
                    <div class="col-span-2 lg:col-span-1 flex flex-col gap-4">
                        <a href="/" class="inline-flex items-baseline select-none">
                            <img src="/images/logo/Safeword-icon.svg" alt="" style="width: 250px;">
                        </a>
                        <p class="text-gray-400 text-sm leading-relaxed max-w-[240px]">
                            Design amazing digital experiences that create more happy in the world.
                        </p>
                    </div>

                    <!-- Nav columns: 2-col on mobile/tablet, 4 individual cols on desktop -->
                    <div *ngFor="let col of navColumns; trackBy: trackByIndex" class="flex flex-col gap-3">
                        <h4 class="text-gray-900 font-semibold text-sm">{{ col.heading }}</h4>
                        <ul class="flex flex-col gap-2.5">
                            <li *ngFor="let link of col.links; trackBy: trackByIndex">
                                <a [href]="link.href"
                                    class="text-gray-500 text-sm hover:text-[#e0144c] transition-colors duration-200">{{
                                    link.label }}</a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>

        <!-- ══ 3. Bottom bar ══════════════════════════════════ -->
        <div class="border-t border-gray-100">
            <div class="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-5
                flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">

                <!-- copyright -->
                <p class="text-gray-400 text-sm text-center sm:text-left order-2 sm:order-1">
                    &copy; {{ currentYear }} Safeword. All rights reserved
                </p>

                <!-- social icons -->
                <div class="flex items-center gap-4 sm:gap-5 order-1 sm:order-2">
                    <a *ngFor="let social of socials; trackBy: trackByIndex" [href]="social.href"
                        [attr.aria-label]="social.label"
                        class="w-5 h-5 text-[#e0144c] hover:text-[#c0103f] hover:scale-110
                        transition-all duration-200 flex items-center justify-center flex-shrink-0"
                        [innerHTML]="social.safeHtml"></a>
                </div>

            </div>
        </div>
    </div>
</footer>